var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCategory)?_c('Category',{attrs:{"info":_vm.page}}):_c('Article',{attrs:{"page":_vm.page}})
}
var staticRenderFns = []

export { render, staticRenderFns }